export enum TAB_INDEXES {
  HOLIDAYS = 0,
  HOTEL_ONLY = 1,
  ESCORTED_TOURS = 2,
  RIVER_CRUISES = 3,
  PRIVATE_TOURS = 4,
  MULTI_CENTRE = 5,
  CRUISES = 6
}
